module.exports = __webpack_public_path__ + "static/media/EscherStairs.461e83f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/client/assets/images/EscherStairs.jpg
// module id = 102
// module chunks = 0